var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-lg-4 col-sm-12 col-md-6" }, [
    _c("div", { staticClass: "lc-project-box box-shadow" }, [
      _c(
        "div",
        {
          class: [
            "lc-project",
            { "lc-voted": _vm.ranking != null, "lc-fade-voted": _vm.fadeVoted }
          ]
        },
        [
          _c("ProjectCardCarousel", {
            attrs: {
              images: _vm.getProjImages(),
              lifeDetailsUrl: _vm.project.life_details_url,
              projectData: _vm.project
            }
          }),
          _c("BadgesComponent", {
            attrs: {
              badgesData: _vm.getBadgesData(),
              projectId: _vm.project.id
            }
          }),
          _vm.voting_enabled
            ? _c(
                "div",
                {
                  class: [
                    "lc-data-panel",
                    _vm.voting_enabled ? "vote-panel" : ""
                  ]
                },
                [
                  _vm.voting_enabled
                    ? _c("Vote", {
                        attrs: {
                          id: _vm.project.id,
                          isCompact: true,
                          year: _vm.year
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }